export enum EUserStatus {
  New = 'NEW',
  Visited = 'VISITED',
  Authorized = 'AUTHORIZED',
}

export interface IUserState {
  status: EUserStatus;
  phone?: string;
}
